const ID_REPLACEMENT_MARKER = 'id_replacement_marker';

let siteData;

function getSiteData() {
  if (_.isEmpty(siteData)) {
    const dataEl = document.querySelector('#site-link-data');
    siteData = dataEl ? JSON.parse(dataEl.getAttribute('data')) : {};
  }
  return siteData;
}

export const siteLinkData = {
  getPath(pageName, idValue = null) {
    const path = getSiteData()[pageName];

    if (window.chirpEnv === 'development') {
      if (typeof path === 'undefined') {
        throw new Error('Invalid path: this path does not exist in site_link_helper.rb');
      }
    }

    if (!idValue) {
      return path;
    }
    return path.replace(ID_REPLACEMENT_MARKER, idValue);
  },
};
